import { DownloadOutlined, FileTextOutlined } from '@ant-design/icons'
import { Space } from 'antd'
import { MemberProps } from 'app/components/Core/convention'
import KButton from 'app/components/Modules/General/KButton'
import { RecordType } from 'app/constants/GlobalTypes'
import * as React from 'react'

import { mapInvoice } from '../helper'

type Props = {
  setInvoice?: (invoice: IInvoice) => void
}

const InvoiceAction: React.FC<MemberProps<IInvoice | IInvoiceItem, Props>> = ({
  member,
  props = {}
}) => {
  if (member.__typename === 'Invoice') {
    return <InvoiceActions member={member as IInvoice} props={props} />
  }
  return null
}

function InvoiceActions({ member, props: { setInvoice } }: MemberProps<IInvoice, Props>) {
  const onOpen = () => setInvoice?.(mapInvoice(member))

  return (
    <Space>
      <KButton
        type="default"
        size="small"
        onClick={onOpen}
        showTitle={false}
        recordType={RecordType.invoice}
        action="open"
        icon={<FileTextOutlined />}
        disabled={!member}
      />
      <KButton
        type="default"
        size="small"
        href={member.url}
        showTitle={false}
        recordType={RecordType.invoice}
        action="download"
        disabled={!member.url}
        icon={<DownloadOutlined />}
      />
    </Space>
  )
}

export default InvoiceAction
